import { Reducer } from "redux";
import { LeagueState } from "../constants";
import { LeagueActions, LeagueActionTypes } from "../actions/types";

const initialState: LeagueState = {
  value: [],
  error: null,
  status: "idle",
  categories: [],
};

const reducer: Reducer<LeagueState> = (
  state = initialState,
  action: LeagueActions
) => {
  switch (action.type) {
    case LeagueActionTypes.RESET: {
      return {
        value: [],
        categories: [],
        error: null,
        status: "idle",
        teamStatistics: [],
        playerStatistics: [],
        playerStatisticsDetail: [],
        teamStatisticsDetail: [],
        tow: [],
      };
    }
    case LeagueActionTypes.FETCH_LEAGUES: {
      return { ...state, status: "loading" };
    }
    case LeagueActionTypes.FETCH_SUCCESS: {
      const newLeagueIds = new Set(action.payload.response.map((l) => String(l.id)));
      const leaguesNotInAoi = state.value.filter(
        (existingLeague) => !newLeagueIds.has(String(existingLeague.id))
      );
      return {
        ...state,
        status: "idle",
        value: [...action.payload.response, ...leaguesNotInAoi],
        error: null,
      };
    }

    case LeagueActionTypes.FETCH_CATEGORIES_SUCCESS: {
      return {
        ...state,
        categories: action.payload,
      };
    }
    case LeagueActionTypes.FETCH_SUCCESS_SINGLE: {
      const existingIds = new Set(state.value.map((l) => String(l.id)));
      const newLeagues = action.payload.filter(
        (league) => !existingIds.has(String(league.id))
      );
      return {
        ...state,
        status: "idle",
        value: [...state.value, ...newLeagues],
        error: null,
      };
    }
    case LeagueActionTypes.FETCH_ERROR: {
      return { ...state, status: "failed", error: action.payload };
    }
    default: {
      return state;
    }
  }
};

export { reducer as leagueReducer };
